const UPDATE_CIGGARETES_REQUEST = "@update/CIGGARETESREQUEST";
const UPDATE_CIGGARETES_SUCCESS = "@update/CIGGARETESSUCCESS";
const UPDATE_CIGGARETES_ERROR = "@update/CIGGARETESERROR";

export default {
  UPDATE_CIGGARETES_REQUEST,
  UPDATE_CIGGARETES_SUCCESS,
  UPDATE_CIGGARETES_ERROR,
};
